export class ReleaseInfo {
  heading: string;
  features: [string];
  bugfixesS: [string];
  constructor(heading: string, features: [string], bugfixesS: [string]) {
    this.heading = heading;
    this.features = features;
    this.bugfixesS = bugfixesS;
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/models/releaseInfo.ts